import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextareaAutosize,
} from '@mui/material'
import { useFormik } from 'formik'
import { inject, observer } from 'mobx-react'
import { message, Button, Upload } from 'antd'
import { AiOutlineSend } from 'react-icons/ai'
import * as Yup from 'yup'
import {
  CloseOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  UploadOutlined,
} from '@ant-design/icons'
const ProposalComment = props => {
  let {
    open,
    handleClose,
    proposalCode,
    onCommentSuccess,
    proposalStore,
    fileStore,
  } = props
  const [fileList, setFileList] = useState([])
  const formik = useFormik({
    initialValues: {
      content: '',
    },
    validationSchema: Yup.object({
      content: Yup.string().trim(),
    }),
    onSubmit: async values => {
      if (values.content.trim() === '') {
        message.warning('Vui lòng nhập nội dung ý kiến hợp lệ!')
        closePopup()
        return
      }
      setButtonBlock(true)
      try {
        const uploadFileList = fileList.map(file => file.originFileObj)
        const batchUploadArr = uploadFileList.map(file => {
          const formData = new FormData()
          formData.append('file', file)
          return fileStore.uploadFile(formData)
        })

        let uploadedFiles = []
        const response = await Promise.all(batchUploadArr)
        uploadedFiles = response.map(res => res.data.file_id)

        const commentData = {
          content: values.content.replace(/\s+/g, ' ').trim(),
          file_ids: uploadedFiles,
        }
        if (!commentData.content) {
          message.error('Vui lòng không để trống ý kiến.')
          return
        }
        await proposalStore.createOtherComment(proposalCode, commentData)
        message.success('Đăng ý kiến thành công!')
        onCommentSuccess()
      } catch (err) {
        // console.log(err)
      } finally {
        proposalStore.getOtherComment(proposalCode)
        closePopup()
      }
    },
  })
  const [buttonBlock, setButtonBlock] = useState(false)

  const handleFileChange = ({ fileList: newFileList }) => {
    setFileList(newFileList)
  }

  const closePopup = () => {
    handleClose()
    setButtonBlock(false)
    setFileList([])
    formik.resetForm()
  }
  const getFileIcon = fileName => {
    const extension = fileName.split('.').pop().toLowerCase()
    switch (extension) {
      case 'pdf':
        return (
          <FilePdfOutlined style={{ color: '#d32f2f', fontSize: '16px' }} />
        )
      case 'doc':
      case 'docx':
        return (
          <FileWordOutlined style={{ color: '#1976d2', fontSize: '16px' }} />
        )
      case 'xls':
      case 'xlsx':
        return (
          <FileExcelOutlined style={{ color: '#2e7d32', fontSize: '16px' }} />
        )
      case 'jpg':
      case 'jpeg':
      case 'png':
        return (
          <FileImageOutlined style={{ color: '#388e3c', fontSize: '16px' }} />
        )
      default:
        return (
          <FileImageOutlined style={{ color: '#757575', fontSize: '16px' }} />
        )
    }
  }
  return (
    <Dialog
      open={open}
      onClose={closePopup}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100vw',
            maxWidth: '100vw', // Set your width here
            mx: 0,
          },
        },
      }}>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#2c65ac] pt-3"
          sx={{
            fontWeight: 700,
          }}>
          <div className="flex justify-between items-center">
            <span>Đăng ý kiến</span>
            <Button
              onClick={closePopup}
              className="flex items-center justify-center m-0 p-0 bg-white border-none shadow-none hover:bg-white active:bg-white focus:bg-white h-4 w-4">
              <CloseOutlined className="text-red-600" />
            </Button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="scroll-dialog-description"
            tabIndex={-1}
            className="min-h-[50px] mt-4">
            <TextareaAutosize
              value={formik.values.content}
              id="content"
              name="content"
              minRows={4}
              maxRows={10}
              placeholder="Nhập nội dung"
              className="bg-[#F8F8F8] w-full p-3 rounded-md "
              onChange={formik.handleChange}
            />
          </DialogContentText>
        </DialogContent>
        <div className="flex justify-start align-center mt-[-20px] pb-4 px-8 font-medium">
          <span
            style={{
              fontSize: '13px',
              color: '#000',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}>
            {fileList[0]?.name && (
              <div className="file-name-display mt-2 text-blue-600 flex items-center gap-1">
                {getFileIcon(fileList[0].name)}
                <span style={{ fontSize: '14px' }} title={fileList[0].name}>
                  {fileList[0].name.length > 50
                    ? `${fileList[0].name.slice(0, 50)}...`
                    : fileList[0].name}
                </span>
              </div>
            )}
          </span>
        </div>
        <DialogActions>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            {/* <Button
            sx={{ fontWeight: 600 }}
            onClick={closePopup}
            className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary rounded-full"
          >
            Đóng
          </Button> */}
            <div className="flex items-center justify-center">
              <Upload
                beforeUpload={() => false}
                maxCount={1}
                fileList={fileList}
                onChange={handleFileChange}
                showUploadList={false}>
                <Button
                  icon={<UploadOutlined />}
                  style={{
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary">
                  Tải file
                </Button>
              </Upload>
            </div>
            {formik.values.content.trim() === '' || buttonBlock ? (
              <button
                disabled={true}
                style={{ fontWeight: 600, opacity: 0.2 }}
                className="opacity-[0.3] uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]">
                Gửi
              </button>
            ) : (
              <button
                type="submit"
                style={{ fontWeight: 600 }}
                className="uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]"
                onClick={handleClose}>
                Gửi
              </button>
            )}
          </div>
        </DialogActions>
      </form>
    </Dialog>
  )
}
export default inject('proposalStore', 'fileStore')(observer(ProposalComment))
